import { useTokens } from '@frontend/shared';
import { Spinner } from '@frontend/shared/web';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { AuthenticatedShell } from '../components/layout/AuthenticatedShell';
import { AccountProvider } from '../contexts/AccountContext';
import { ToastProvider } from '../contexts/ToastContext';

export const AuthenticatedLayout = () => {
  const { tokens } = useTokens();
  const navigate = useNavigate();

  useEffect(() => {
    if (tokens === null) {
      navigate('/login', { replace: true });
    }
  }, [tokens, navigate]);

  if (tokens === undefined || tokens === null) {
    return <Spinner />;
  }

  return (
    <AccountProvider
      renderError={retry => (
        <div className="h-viewport flex items-center justify-center bg-zinc-50 px-6">
          <div className="text-center max-w-md flex flex-col gap-3">
            <h1 className="text-lg font-semibold text-zinc-900">Erreur de chargement</h1>
            <p className="text-sm text-zinc-600">
              Impossible de récupérer les informations du compte. Vérifiez votre connexion ou contactez votre
              administrateur Allocab.
            </p>
            <button
              type="button"
              onClick={retry}
              className="self-center h-9 px-4 mt-2 text-sm font-medium bg-zinc-900 text-white rounded-md hover:bg-zinc-800 transition-colors"
            >
              Réessayer
            </button>
          </div>
        </div>
      )}
    >
      <ToastProvider>
        <AuthenticatedShell>
          <Outlet />
        </AuthenticatedShell>
      </ToastProvider>
    </AccountProvider>
  );
};
